<div class='ipensii-colored-card pb-3 pr-3' [style]='style'>
  <ng-content></ng-content>
</div>
